import type { AxiosInstance, AxiosRequestConfig } from 'axios'
import type { ApiResponseBody } from '@/types/api'

/** Unwraps the `{ data: T }` envelope, tolerating endpoints that return T directly. */
export function unwrap<T>(body: ApiResponseBody<T>): T {
  if (body !== null && typeof body === 'object' && 'data' in (body as Record<string, unknown>)) {
    return (body as { data: T }).data
  }
  return body as T
}

/**
 * Returns the unwrapped payload. Services compose it with a typed endpoint:
 *
 *   getTokenFlows: (q: FlowQuery) =>
 *     apiCall<TokenFlows>(internalClient, { method: 'GET', url: ENDPOINTS.FLOWS, params: q })
 *
 * The wrapper exists so the unwrap step lives in exactly one place.
 */
export async function apiCall<T>(client: AxiosInstance, config: AxiosRequestConfig): Promise<T> {
  const res = await client.request<ApiResponseBody<T>>(config)
  return unwrap<T>(res.data)
}
